import Button from "components/button";
import Input from "components/input";
import useLoginForm from "modules/login/useLoginForm";

const LoginPage = () => {
  const {
    loginHandler,
    register,
    errors,
    isLoading,
    rememberMe,
    rememberMeHandler,
    t,
  } = useLoginForm();

  return (
    <div className="bg-white formLogin w-[450px] h-[424px] absolute mx-auto left-0 right-0 rounded-xl shadow-xl top-[22vh] z-[100]">
      <form
        onSubmit={loginHandler}
        className="p-[32px] font-poppins"
      >
        <h1 className="text-xl font-semibold text-shark">
          {t("form-title")}
        </h1>
        <small className="text-sm font-light text-[#7C7C7C]">
          {t("form-subtitle")}
        </small>
        <div className="form-login flex flex-col pt-8 gap-4 w-full">
          <Input
            label={t("label-email")}
            {...register("email")}
            placeholder={t("placeholder-email")}
            error={errors.email}
          />
          <Input
            label={t("label-password")}
            {...register("password")}
            placeholder={t("placeholder-password")}
            type="password"
            error={errors.password}
          />
          <div className="flex justify-end items-center gap-2">
            <input type="checkbox" id="rememberMe" checked={rememberMe} onChange={rememberMeHandler} />
            <label htmlFor="rememberMe">{t("label-remember-me")}</label>
          </div>
        </div>
        <Button
          type="submit"
          className="text-center w-full mt-5 text-base font-semibold"
          disabled={isLoading}
        >
          {t("btn-login")}
        </Button>
      </form>
    </div>
  );
};

export default LoginPage;
